/*
 * pv-load-more.js
 * ---------------------------------------------------------------------------
 * „Weitere Werke laden" im Collection-Grid.
 *
 * Der Link zeigt serverseitig auf die nächste Seite und funktioniert dadurch
 * auch ohne JavaScript. Ist das Skript da, wird die nächste Seite über die
 * Section Rendering API geholt und ans bestehende Raster angehängt — die Seite
 * bleibt stehen, die Scrollposition bleibt erhalten.
 *
 * Die Bindung läuft über einen Delegate auf dem Dokument, weil facets.js das
 * Raster bei jedem Filterwechsel komplett austauscht. Der Zustand steht in den
 * data-Attributen des Containers, nicht im Skript.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var CONTAINER = '[data-pv-load-more]';
  var BUTTON = '[data-pv-load-more-btn]';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function num(el, name, fallback) {
    var v = parseInt(el.getAttribute(name), 10);
    return isNaN(v) ? fallback : v;
  }

  /* Styles und Skripte aus dem Fragment werfen — die stehen durch die erste
     Seite längst im Dokument. */
  function strip(node) {
    toArray(node.querySelectorAll('style, link[rel="stylesheet"], script')).forEach(function (el) {
      el.parentNode.removeChild(el);
    });
    return node;
  }

  function buildUrl(sectionId, page) {
    var url = new URL(window.location.href);
    url.searchParams.set('page', String(page));
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  }

  function targetList(container) {
    var scope = container.closest('.product-grid-container') || document;
    var grid = scope.querySelector('#product-grid') || document.getElementById('product-grid');
    if (!grid) return null;
    var lists = grid.querySelectorAll('ul.product-grid');
    return lists.length ? lists[lists.length - 1] : null;
  }

  function finish(container, button, page, totalPages, pageSize, totalItems) {
    var seen = Math.min(page * pageSize, totalItems);
    var progress = container.querySelector('[data-pv-load-more-progress]');
    if (progress) progress.textContent = seen + ' von ' + totalItems + ' Werken';

    container.setAttribute('data-current-page', String(page));

    if (page >= totalPages) {
      if (button && button.parentNode) button.parentNode.removeChild(button);
    } else if (button) {
      var next = new URL(window.location.href);
      next.searchParams.set('page', String(page + 1));
      button.setAttribute('href', next.toString());
    }
  }

  function load(container, button) {
    if (container.getAttribute('data-pv-busy') === 'true') return;

    var sectionId = container.getAttribute('data-section-id');
    var page = num(container, 'data-current-page', 1) + 1;
    var totalPages = num(container, 'data-total-pages', 1);
    var pageSize = num(container, 'data-page-size', 24);
    var totalItems = num(container, 'data-total-items', 0);
    var list = targetList(container);

    if (!sectionId || !list || page > totalPages) return;

    container.setAttribute('data-pv-busy', 'true');
    if (button) {
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Werke werden geladen …';
    }

    fetch(buildUrl(sectionId, page), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.getElementById('product-grid');
        if (!grid) throw new Error('Kein Raster im Fragment');

        toArray(grid.querySelectorAll('li.grid__item')).forEach(function (item) {
          /* Die Beratungszeile kommt mit: sie steht im festen Takt des
             Rasters und soll auch in nachgeladenen Seiten wiederkehren. */
          list.appendChild(strip(item));
        });

        if (button) button.textContent = 'Weitere Werke laden';
        finish(container, button, page, totalPages, pageSize, totalItems);

        if (typeof window.initializeScrollAnimationTrigger === 'function') {
          try {
            window.initializeScrollAnimationTrigger(list);
          } catch (e) {
            /* noop */
          }
        }

        document.dispatchEvent(
          new CustomEvent('pv:load-more:appended', { detail: { page: page } })
        );
      })
      .catch(function (error) {
        console.warn('[pv-load-more] Nachladen fehlgeschlagen:', error);
        /* Der Link behält sein href — ein Klick führt dann wie früher auf die
           nächste Seite, statt ins Leere zu laufen. */
        if (button) {
          button.textContent = 'Weitere Werke laden';
          button.removeAttribute('data-pv-load-more-btn');
        }
      })
      .then(function () {
        container.removeAttribute('data-pv-busy');
        if (button) button.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest(BUTTON) : null;
    if (!button) return;
    var container = button.closest(CONTAINER);
    if (!container) return;
    event.preventDefault();
    load(container, button);
  });
})();
